import { render, staticRenderFns } from "./MessageModal.vue?vue&type=template&id=256f8797&scoped=true&"
import script from "./MessageModal.vue?vue&type=script&lang=ts&"
export * from "./MessageModal.vue?vue&type=script&lang=ts&"
import style0 from "./MessageModal.vue?vue&type=style&index=0&id=256f8797&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256f8797",
  null
  
)

export default component.exports